// @ts-nocheck
import React from 'react';
import FormInput from '../../../common/FormInput';
import FormColourPicker from '../../../common/FormColourPicker';
import FormImage from '../../../common/FormImage';
import { useTranslation } from 'react-i18next';

const PlatformForm = ({ platform, register, errors, control, setFile }) => {
  const { t } = useTranslation();
  return (
    platform && (
      <>
        <FormInput
          register={register}
          required={true}
          error={errors.name}
          errorMessage={t('Required')}
          name="name"
          label={t('Name')}
          defaultValue={platform.name || ''}
          autoFocus={true}
          testId="platform-name"
        />
        <FormColourPicker
          control={control}
          name="colourHex"
          label={t('Colour')}
          extraRowClasses="align-items-start"
          defaultValue={platform.colourHex || 'transparent'}
          testId="platform-colour"
        />
        <FormImage
          control={control}
          name="image"
          label={t('Image')}
          setFile={setFile}
          value={platform.imageId}
          testId="platform-image"
        />
      </>
    )
  );
};



export default PlatformForm;
